import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PageSection from '../../../../components/UI/PageSection'
import PageTitle from '../../../../components/UI/PageTitle'
import UpdateUserDetailsForm from './components/UpdateUserDetailsForm'
import CronActions from './components/CronActions/CronActions'
import UserMethods from '../../../../utils/userMethods'
import RenderIf from '../../../../components/UI/RenderIf'

function Settings() {
  const { t } = useTranslation()
  const authUser = UserMethods.getUser()
  useEffect(() => {
    document.title = `Demo CRM - ${t('settings')}`
  }, [t])

  return (
    <PageSection>
      <PageTitle text="settings" />
      <UpdateUserDetailsForm />
      <RenderIf isTrue={authUser?.user.user_type === 'DIRECTOR'}>
        <CronActions />
      </RenderIf>
    </PageSection>
  )
}

export default Settings
